export const stringFirstUpperCase = (string) => {
    if (string) {
        return string.replace(/(^\w|\s\w)/g, (m) => m.toUpperCase());
    }
    return string;
};
